import axios from 'axios';

export default {
  getRevisionId () {
    // MEMO: キャッシュを無効化するためハッシュを付与して取得する
    const hash = new Date().getTime();
    return axios.get(`/revision.json?${hash}`);
  },
};
